import React from 'react';

const CoverPage = ({ personalInfo, reportDate }) => {
    return (
        <div className="pdf-page cover-page" style={{ height: '297mm', width: '210mm', padding: '0', position: 'relative', overflow: 'hidden', background: '#0f172a' }}>
            {/* Design Elements */}
            <div style={{ position: 'absolute', top: '-10%', right: '-10%', width: '600px', height: '600px', borderRadius: '50%', background: 'linear-gradient(135deg, rgba(6, 150, 104, 0.1) 0%, rgba(6, 150, 104, 0) 100%)' }}></div>
            <div style={{ position: 'absolute', bottom: '0', left: '0', width: '100%', height: '8px', background: '#069668' }}></div>
            
            <div style={{ padding: '100px 80px', position: 'relative', height: '100%', display: 'flex', flexDirection: 'column', color: '#fff' }}>
                <div style={{ marginBottom: '60px', opacity: '0.8' }}>
                    <img src="/Yathartha-Logo.png" alt="Logo" style={{ height: '40px', filter: 'brightness(0) invert(1)' }} />
                </div>
                
                <div style={{ marginTop: '40px' }}>
                    <div style={{ fontSize: '14px', fontWeight: '800', letterSpacing: '4px', color: '#069668', marginBottom: '20px' }}>PRECISION WEALTH ANALYSIS</div>
                    <h1 style={{ fontSize: '72px', fontWeight: '900', color: '#fff', marginBottom: '10px', lineHeight: '0.9' }}>
                        Financial<br />
                        <span style={{ color: '#069668' }}>Diagnosis</span><br />
                        Report
                    </h1>
                    <div style={{ width: '140px', height: '8px', background: '#069668', borderRadius: '4px', marginTop: '30px' }}></div>
                </div>
                
                <div style={{ marginTop: 'auto', marginBottom: '80px' }}>
                    <div style={{ borderLeft: '4px solid #069668', paddingLeft: '30px' }}>
                        <p style={{ fontSize: '14px', opacity: '0.6', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '5px' }}>Prepared Exclusively For</p>
                        <h2 style={{ fontSize: '42px', fontWeight: '800', color: '#fff', marginBottom: '5px' }}>{personalInfo?.name || 'Valued Client'}</h2>
                        <p style={{ fontSize: '20px', color: '#069668', fontWeight: '700' }}>{reportDate || new Date().toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}</p>
                    </div>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', opacity: '0.9' }}>
                    <div style={{ fontSize: '13px', lineHeight: '1.6', color: '#94a3b8', maxWidth: '400px' }}>
                        This document provides a comprehensive analysis of your wealth machine, identifying gaps and providing a roadmap to achieve ₹10 Crores in net worth.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoverPage;
